import React from 'react';
import classNames from 'classnames';

export type SocialNetworks = 'Facebook' | 'Twitter' | 'YouTube' | 'RSS';

export interface SocialLinksProps {
  className?: string;
  id?: string;
  socialNetworks: [SocialNetworks, string][];
}
const SocialLinks = ({ className, id, socialNetworks }: SocialLinksProps): JSX.Element => {
  return (
    <div className="usa-footer__social-links grid-row grid-gap-1">
      {socialNetworks.map(([network, href]) => {
        return (
          <div className="grid-col-auto" key={network}>
            <a
              id={id}
              className={classNames(className, 'usa-social-link', `usa-social-link--${network.toLowerCase()}`)}
              href={href}
              data-testid={`uswds-react-social-${network}`}
            >
              <span>{network}</span>
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default SocialLinks;
